import React from 'react';
import { TasksErrors } from '../../../store/tasks';
import './TasksErrorsNotification.css';

type Props = { taskId: string; errors: TasksErrors[string] };

const TasksErrorsNotification = ({ taskId, errors }: Props) =>
    <div className="tasks-errors">
        <div>Task `{taskId}`</div>
        {Object.entries(errors).map(([key, error], i) => <div key={key} className="error-entry">{error}</div>)}
    </div>;

export default TasksErrorsNotification;
